import { QueryClient } from "@tanstack/react-query";

import { queryKeys } from "#shared/queryKeys/queryKeys";

export const invalidateQuoteRequestLineDetails = (queryClient: QueryClient, lineIds: string[]) => {
  lineIds.forEach((lineId) => {
    void queryClient.invalidateQueries({ queryKey: queryKeys.quoteRequestLines.detail(lineId) });
  });
};
